import React, { useEffect, useState } from 'react';

import { useConfig } from '../../../ConfigContext';
import { ProviderLink } from '../provider/ProviderLink';
import logoSteam from '../../../_assets/steam.svg';
import { Popup } from '../../../utils/Popup';
import { del, post } from '../../../utils/Request';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { RequestError } from '../../../Error.model';
import { ProviderNames } from '../ProviderEnum';

interface Props {
  showLink?: boolean;
  showUnlink?: boolean;
}

export function Steam({ showLink, showUnlink }: Props): JSX.Element {
  const config = useConfig();
  const auth = useAuth();

  const [error, setError] = useState<RequestError | null>(null);

  const link = (): void => {
    const authUrl = 'https://steamcommunity.com/oauth/login?'
     + `response_type=token&client_id=${config.serverConfig.providers.steam.clientId}`;

    Popup.open(authUrl, 'steam_auth');
  };

  const unlink = (): void => {
    setError(null);
    del(`${config.clientConfig.host}/players/me/unlink/providers/steam`)
      .then(() => {
        auth.getPlayer();
      }).catch((err: RequestError) => {
        setError(err);
      });
  };

  const onLinkMessage = (event: MessageEvent): void => {
    setError(null);
    if (event.data.steamData) {
      post(`${config.clientConfig.host}/players/me/link`, {
        data: {
          type: ProviderNames.STEAM,
          data: event.data.steamData,
        },
      })
        .then(() => {
          setError(null);
          auth.getPlayer();
        })
        .catch((err: RequestError) => {
          setError(err);
        });
    }
  };

  useEffect(() => {
    window.addEventListener('message', onLinkMessage);

    return () => {
      window.removeEventListener('message', onLinkMessage);
    };
  }, []);

  return (
    <ProviderLink
      providerName={ProviderNames.STEAM}
      logo={logoSteam}
      link={link}
      unlink={unlink}
      error={error}
      showLink={showLink}
      showUnlink={showUnlink}
    />
  );
}
